import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  BILLING_MODE_MONTH,
  BILLING_MODE_YEAR_FIXED_DISCOUNT_PERCENT,
} from '@/config/appConstants';
import { BillingMode } from '@/types';

export type BillingModeSwitchProps = {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  billingModeDefaultValue: BillingMode;
  className?: string;
};

export const BillingModeSwitch = ({
  onChange,
  className,
  billingModeDefaultValue = BILLING_MODE_MONTH,
}: BillingModeSwitchProps) => {
  const { t } = useTranslation();

  return (
    <div className={clsx('w-[200px] m-auto mb-0', className)}>
      <span className="text-sm ml-4 font-black">{t('BillingMode.title')}</span>
      <div className="relative mt-1.5">
        <label htmlFor="switcher" className="flex justify-center cursor-pointer">
          <div className="relative flex justify-between w-[200px] h-8 bg-white rounded-full p-4">
            <input
              id="switcher"
              type="checkbox"
              className="hidden peer"
              onChange={onChange}
              defaultChecked={!(billingModeDefaultValue === BILLING_MODE_MONTH)}
            />
            <span className="text-center flex-grow relative z-[5] self-center transition text-white peer-checked:text-black mr-4 capitalize">
              {t('BillingMode.monthly')}
            </span>
            <span className="text-center flex-grow relative z-[5] self-center transition text-black peer-checked:text-white capitalize">
              {t('BillingMode.yearly')}
            </span>
            <span className="absolute toggle z-[4] bg-md-purple h-6 w-[100px] rounded-full transition-all top-[4px] left-[4px] peer-checked:left-[calc(100%-104px)]" />
          </div>
        </label>
        <span className="absolute -right-5 -top-2 text-xs inline-block pt-1 pb-1 px-2 leading-none text-center whitespace-nowrap align-baseline text-xs font-bold bg-md-green text-white rounded-full z-50">
          {`-${BILLING_MODE_YEAR_FIXED_DISCOUNT_PERCENT}%`}
        </span>
      </div>
    </div>
  );
};
